'use strict';

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var Counter = require('crdts/src/G-Counter');

var CounterIndex =
/*#__PURE__*/
function () {
  function CounterIndex(id) {
    _classCallCheck(this, CounterIndex);

    this._index = new Counter(id);
  }

  _createClass(CounterIndex, [{
    key: "get",
    value: function get() {
      return this._index;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(oplog) {
      var _this = this;

      if (this._index) {
        var createCounter = function createCounter(e) {
          return Counter.from(e.payload.value);
        };

        var mergeToIndex = function mergeToIndex(e) {
          return _this._index.merge(e);
        };

        oplog.values.filter(function (e) {
          return e && e.payload.op === 'COUNTER';
        }).map(createCounter).forEach(mergeToIndex);
      }
    }
  }]);

  return CounterIndex;
}();

module.exports = CounterIndex;